import { mapGetters, mapMutations } from 'vuex'

export default {
  data() {
    return {
      onboarding: {
        options: {
          useKeyboardNavigation: true,
          startTimeout: 0,
          debug: false,
          labels: {
            buttonSkip: 'Skip tour',
            buttonPrevious: 'Previous',
            buttonNext: 'Next',
            buttonStop: 'Finish',
          },
        },
        steps: [],
      },
    }
  },
  computed: {
    ...mapGetters({
      settings: 'settings/settings',
    }),
    onboardingDisabled() {
      return this.settings.onboarding.disabled ?? false
    },
    onboardingSeen() {
      return this.settings.onboarding.seen ?? []
    },
  },
  methods: {
    ...mapMutations({
      setSettings: 'settings/setSettings',
    }),
    onboardingSetSeen(tour) {
      if (!tour) return

      const seen = this.onboardingSeen
      if (seen.includes(tour)) return

      this.settings.onboarding.seen.push(tour)
      this.setSettings(this.settings)
    },
    onboardingHasSeen(tour) {
      return this.onboardingSeen.includes(tour)
    },
  },
}
